import { useEffect } from "react"

/**
 * 非制御コンポーネントを制御コンポーネントのように扱えるようにするhooksです。
 * パフォーマンス等の理由で非制御にしているコンポーネントを、利用側から見た場合には制御コンポーネントかのように扱います。
 * @see https://ja.reactjs.org/docs/uncontrolled-components.html
 */
const useUncontrolledAsControlled = <T extends HTMLInputElement | HTMLTextAreaElement>(
  ref: React.RefObject<T>,
  value: string | undefined
) => {
  // propsのvalueが変わった場合に、そのvalueでDOMを更新します
  useEffect(() => {
    if (ref.current === null || value === undefined) return

    // valueの内容が同じでも代入されるとオートコンプリート時のstyleが消えるため、valueが違う時のみ代入するようにしています。
    if (ref.current.value !== value) {
      ref.current.value = value
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])
}

export default useUncontrolledAsControlled
